import * as action_types from './constants';

const initialState = {
  ads: {},
  ad: {},
  adsOption: {},
  adOption: {},
  adProducts: {},
  adProduct: {},
  adProductsOption: {},
  rewards: {},
  reward: {},
};

export default (state = initialState, action) => {
  const { type, data, meta } = action;
  switch (type) {
    case action_types.ADS_LIST:
      return { ...state, ads: data };
    case action_types.ADS_DETAIL:
      return { ...state, ad: data };      
    case action_types.ADS_PRODUCT_LIST:
      return { ...state, adProducts: data, adProductsOption: meta };
    case action_types.ADS_PRODUCT_DETAIL:
      return { ...state, adProduct: data };
    case action_types.REWARDS_LIST:
      return { ...state, rewards: data };
    case action_types.REWARDS_DETAIL:
      return { ...state, reward: data };
    default:
      return state;
  }
};
